import { GridColumn, GridLayout, GridRow } from '@hh.ru/magritte-ui';

import Gap from 'bloko/blocks/gap';

import anonymousLinks from 'components/Footer/Links/anonymous';
import applicantLinks from 'components/Footer/Links/applicant';
import employerLinks from 'components/Footer/Links/employer';
import List from 'components/Footer/List';

import 'components/Footer/Footer.less';

const Footer = () => (
    <footer className="footer">
        <Gap top>
            <GridLayout>
                <GridRow>
                    <GridColumn xs={4} s={8} m={12} l={12} xl={12} xxl={12}>
                        <List links={employerLinks} />
                    </GridColumn>
                    <GridColumn xs={4} s={8} m={12} l={12} xl={12} xxl={12}>
                        <List links={applicantLinks} />
                    </GridColumn>
                    <GridColumn xs={4} s={8} m={12} l={12} xl={12} xxl={12}>
                        <List links={anonymousLinks} />
                    </GridColumn>
                </GridRow>
            </GridLayout>
        </Gap>
    </footer>
);

export default Footer;
